<template>
  <div
    class="recipe-card"
  >
    <div class="recipe-card__inner">
      <div class="recipe-card__image">
        <div
          class="recipe-card__image-bg"
          :style="'background-image: url(' + recipe.imageUrl + ');'"
        />
      </div>
      <h3>
        <a
          :href="recipe.url"
          data-gtmcat="recipe engagement"
          data-gtmaction="click"
          :data-gtmlabel="recipe.title | striphtml"
        >
          <span>{{ recipe.title | striphtml }}</span>
        </a>
      </h3>
    </div>
    <div
      class="recipe-card__pattern"
      aria-hidden="true"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
      >
        <rect
          width="100%"
          height="100%"
          fill="url(#pattern_xAU1k)"
          opacity="1"
        />
      </svg>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
// import VueLazyload from 'vue-lazyload'
 
// Vue.use(VueLazyload)
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'dist/error.png',
//   loading: 'dist/loading.gif',
//   attempt: 1
// })

export default {
  name: "Recipe",
  components: {
    // eslint-disable-next-line
    // VueLazyload,
  },
  props: {
    recipe: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    
  },
  created() {
    
  },
  methods: {

  }
}
</script>

